import { kea } from "kea";
import api from '../utils/api';


export const profilelogic = kea({
	actions: {
		fetch: true,
		update: (profile) => ({ profile }),
		updateMobile: (profile) => ({ profile }),
		confirmVerificationCode: (code) => ({ code }),

		set: (profile) => ({ profile }),
		setError: (error) => ({ error }),
		setBlock: (block_error) => ({ block_error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		profile: [null, {
			set: (_, { profile }) => profile,
		}],
		logged_in: [false, {
			set: () => true
		}],
		loading: [false, {
			fetch: () => true,
			update: () => true,
			updateMobile: () => true,
			confirmVerificationCode: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		block_error: [null, {
			set: () => null,
			setSuccess: () => null,
			setBlock: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async (_, breakpoint) => {
			await breakpoint(300);
			let url = '/profile';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setBlock(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.set(json.payload);
			else actions.setBlock(json.error);
		},
		update: async ({ profile }, breakpoint) => {
			await breakpoint(300);
			let url = '/profile';
			let res;
			try {
				res = await api({ url, method: 'put', body: profile });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Profile Updated.');
			} else actions.setError(json.error);
		},
		updateMobile: async ({ profile }, breakpoint) => {
			await breakpoint(300);
			let url = '/profile/mobile';
			let res;
			try {
				res = await api({ url, method: 'put', body: profile });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Code Sent.');
			} else actions.setError(json.error);
		},
		confirmVerificationCode: async ({ code }, breakpoint) => {
			await breakpoint(300);
			let url = '/confirm_verification_code';
			let res;
			try {
				res = await api({ url, method: 'post', body: code });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Code Confirmed.');
			} else actions.setError(json.error);
		}
	})
});

export default profilelogic;